export const PLusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.00017 13.4154C6.74044 13.4154 6.52258 13.3274 6.34658 13.1514C6.17058 12.9754 6.08289 12.7578 6.0835 12.4987V7.91537H1.50017C1.24044 7.91537 1.02258 7.82737 0.846583 7.65137C0.670583 7.47537 0.582888 7.25781 0.583499 6.9987C0.583499 6.73898 0.671499 6.52112 0.847499 6.34512C1.0235 6.16912 1.24105 6.08142 1.50017 6.08203H6.0835V1.4987C6.0835 1.23898 6.1715 1.02112 6.3475 0.845118C6.5235 0.669118 6.74105 0.581423 7.00017 0.582034C7.25989 0.582034 7.47775 0.670035 7.65375 0.846034C7.82975 1.02203 7.91744 1.23959 7.91683 1.4987V6.08203H12.5002C12.7599 6.08203 12.9777 6.17003 13.1537 6.34603C13.3297 6.52203 13.4174 6.73959 13.4168 6.9987C13.4168 7.25842 13.3288 7.47628 13.1528 7.65228C12.9768 7.82828 12.7593 7.91598 12.5002 7.91537H7.91683V12.4987C7.91683 12.7584 7.82883 12.9763 7.65283 13.1523C7.47683 13.3283 7.25928 13.416 7.00017 13.4154Z"
        fill="#407FDD"
      />
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M5.50033 20.1654C4.99616 20.1654 4.56441 19.9857 4.20508 19.6264C3.84574 19.267 3.66638 18.8356 3.66699 18.332V3.66537C3.66699 3.1612 3.84666 2.72945 4.20599 2.37012C4.56533 2.01078 4.99677 1.83142 5.50033 1.83203H12.8337L18.3337 7.33203V10.1737L11.0003 17.4841V20.1654H5.50033ZM12.8337 20.1654V18.2174L17.5545 13.4737L19.5253 15.3987L14.7816 20.1654H12.8337ZM20.1899 14.757L18.242 12.8091L18.8837 12.1674C19.067 11.9841 19.2885 11.8924 19.5482 11.8924C19.808 11.8924 20.0219 11.9841 20.1899 12.1674L20.8316 12.832C20.9996 13.0154 21.0837 13.2332 21.0837 13.4856C21.0837 13.738 20.9996 13.9479 20.8316 14.1154L20.1899 14.757ZM11.917 8.2487H16.5003L11.917 3.66537V8.2487Z"
        fill="black"
      />
    </svg>
  );
};
export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g clipPath="url(#clip0_12834_21598)">
        <path
          d="M10.9997 1.83203C16.0624 1.83203 20.1663 5.93595 20.1663 10.9987C20.1663 16.0614 16.0624 20.1654 10.9997 20.1654C5.93692 20.1654 1.83301 16.0614 1.83301 10.9987C1.83301 5.93595 5.93692 1.83203 10.9997 1.83203ZM9.05542 7.75736C8.89084 7.59121 8.66898 7.49425 8.43526 7.48632C8.20153 7.47839 7.9736 7.56009 7.79814 7.71471C7.62268 7.86932 7.51295 8.08515 7.4914 8.31802C7.46986 8.55089 7.53814 8.78319 7.68226 8.96736L7.75926 9.05445L9.70259 10.9978L7.75926 12.9429C7.59311 13.1075 7.49614 13.3294 7.48821 13.5631C7.48029 13.7968 7.56199 14.0248 7.7166 14.2002C7.87121 14.3757 8.08704 14.4854 8.31991 14.507C8.55278 14.5285 8.78508 14.4602 8.96926 14.3161L9.05542 14.24L10.9997 12.2949L12.9439 14.24C13.1085 14.4062 13.3304 14.5031 13.5641 14.5111C13.7978 14.519 14.0257 14.4373 14.2012 14.2827C14.3767 14.1281 14.4864 13.9122 14.5079 13.6794C14.5295 13.4465 14.4612 13.2142 14.3171 13.03L14.241 12.9429L12.2958 10.9987L14.241 9.05445C14.4072 8.88987 14.5041 8.66801 14.5121 8.43428C14.52 8.20055 14.4383 7.97263 14.2837 7.79717C14.1291 7.6217 13.9132 7.51197 13.6804 7.49043C13.4475 7.46888 13.2152 7.53716 13.031 7.68128L12.9439 7.75736L10.9997 9.70253L9.05542 7.75736Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_12834_21598">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
